import React, { useContext } from "react";
import {
  faServer,
  faShieldHalved,
  faUsersCog,
  faUserShield,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { Box, Collapse, Stack, Typography } from "@mui/material";
import { getRuta, isAccess } from "../../helpers/Helpers";
import { DataContext } from "../../context/DataContext";
import NavItem from "./NavItem";
import { sidebar } from "../../theme";

const Security = ({ drawerIsOpen }) => {
  const [open, setOpen] = React.useState(false);
  const { access } = useContext(DataContext);
  let rout = getRuta();
  return isAccess(access, "SECURITY VER") ? (
    <div>
      <Box
        onClick={() => setOpen(!open)}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "13px",
          padding: "11px 12px",
          borderRadius: "11px",
          cursor: "pointer",
          color: sidebar.itemColor,
          "&:hover": { backgroundColor: "rgba(255,255,255,.06)", color: sidebar.userColor },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", fontSize: 19, color: "inherit", flexShrink: 0 }}>
          <FontAwesomeIcon icon={faShieldHalved} fontSize="inherit" />
        </Box>
        <Typography sx={{ fontSize: 14.5, flex: 1, minWidth: 0 }}>Seguridad</Typography>
        {open ? <ExpandLessRoundedIcon sx={{ fontSize: 18 }} /> : <ExpandMoreRoundedIcon sx={{ fontSize: 18 }} />}
      </Box>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <Stack marginTop={0.3} paddingLeft={drawerIsOpen ? 2 : 0} spacing={0.3}>
          <NavItem to={`${rout}/users`} sub icon={<FontAwesomeIcon icon={faUsersCog} fontSize="inherit" />} label="Usuarios" />
          <NavItem to={`${rout}/rols`} sub icon={<FontAwesomeIcon icon={faUserShield} fontSize="inherit" />} label="Roles" />
          <NavItem to={`${rout}/server`} sub icon={<FontAwesomeIcon icon={faServer} fontSize="inherit" />} label="Servidor" />
        </Stack>
      </Collapse>
    </div>
  ) : null;
};

export default Security;
